/*
 *   Copyright (c) 2021
 *   All rights reserved.
 */
import React from 'react';
import { Col, Row, Image } from 'antd';
import styled, { ITheme } from 'styled-components';

import C68Img from 'src/assets/svg/Logo_Partners/68.png';
import AtkImg from 'src/assets/svg/Logo_Partners/ATK.png';
import BasImg from 'src/assets/svg/Logo_Partners/BAS.png';
import BenzingaImg from 'src/assets/svg/Logo_Partners/benzinga.png';
import BitcoinistImg from 'src/assets/svg/Logo_Partners/bitcoinist.png';
import BloombergImg from 'src/assets/svg/Logo_Partners/bloomberg.png';
import BscarmyImg from 'src/assets/svg/Logo_Partners/bscarmy.png';
import BussinessInsiderImg from 'src/assets/svg/Logo_Partners/bussiness_insider.png';
import CaftImg from 'src/assets/svg/Logo_Partners/CAFT.png';
import CfImg from 'src/assets/svg/Logo_Partners/CF.png';
import ChinapumpImg from 'src/assets/svg/Logo_Partners/chinapump.png';
import CoinPostImg from 'src/assets/svg/Logo_Partners/coin_post.png';
import CoinReaderImg from 'src/assets/svg/Logo_Partners/coin_reader.png';
import CoinTeleImg from 'src/assets/svg/Logo_Partners/cointele.png';
import DakuImg from 'src/assets/svg/Logo_Partners/daku.png';
import DefiRacoonsImg from 'src/assets/svg/Logo_Partners/defi_racoons.png';
import DjImg from 'src/assets/svg/Logo_Partners/DJ.png';
import JinseImg from 'src/assets/svg/Logo_Partners/jinse.png';
import KtsImg from 'src/assets/svg/Logo_Partners/KTS.png';
import MarketWatchImg from 'src/assets/svg/Logo_Partners/market_watch.png';
import TheFinanceSgImg from 'src/assets/svg/Logo_Partners/the_finance_sg.png';
import OmgFinnanceImg from 'src/assets/svg/Logo_Partners/omgfinnance.png';
import PrnImg from 'src/assets/svg/Logo_Partners/LG-PRN.png';
import SatoshiImg from 'src/assets/svg/Logo_Partners/satoshi.png';
import YahooImg from 'src/assets/svg/Logo_Partners/yahoo.png';
import InvestingImg from 'src/assets/svg/Logo_Partners/Investing.png';
import NewsBTCImg from 'src/assets/svg/Logo_Partners/NewsBTC.png';
import BlockSolfi from 'src/assets/svg/Logo_Partners/blocksolfi.png';

export const Wrapper = styled.div`
    max-width: 1272px;
    margin: 0 auto;
    width: 100%;
    margin-top: 160px;
    padding-bottom: 75px;
    .home-section {
        flex: 1;
        justify-content: center;
        margin-top: 60px;
        padding-bottom: 30px;
    }
    .backers-fieldset {
        width: 100%;
        border: 0.5px solid ${({ theme }: { theme: ITheme }) => theme.green2};
        border-radius: 8px;
        .fieldset-title {
            width: 39%;
            color: ${({ theme }: { theme: ITheme }) => theme.white};
            margin-left: 100px;
            padding-left: 20px;
            .title-our {
                font-family: 'Orbitron';
                font-style: normal;
                font-weight: 700;
                font-size: 52px;
                line-height: 66px;
                letter-spacing: 0.02em;
                color: ${({ theme }: { theme: ITheme }) => theme.text3};
            }
            .title-backers {
                color: ${({ theme }: { theme: ITheme }) => theme.white};
            }
        }
    }
    .logo-backer {
        display: flex;
        justify-content: center;
        align-items: center;
        .partners-logo {
            width: 50%;
            margin: 0 auto;
        }
    }
    ${({ theme }: { theme: ITheme }) => theme.mediaWidth.upToMedium`
        max-width: 100%;
        padding: 0 30px;
        margin: 0 auto;
        width: 100%;
        margin-top: 80px;
        .home-section {
            flex: 1;
            justify-content: center;
        }
        .backers-fieldset {
            width: 100%;
            border: none;
            border-radius: none;
            .fieldset-title {
                margin-left: 0;
                padding-left: 0;
                width: unset;
                text-align: center;
                .title-our {
                    font-size: 22px;
                    line-height: 32px;
                    letter-spacing: 0.02em;
                }
            }
        }
        .title-backers {
            font-size: 22px;
            line-height: 32px;
        }
        .logo-backer {
            display: flex;
            justify-content: center;
            align-items: center;
            .partners-logo {
                width: 50%;
                margin: 0 auto;
            }
        }
    `}
`;

const listPartners = [
    {
        name: 'C68',
        logo: <Image className="partners-logo" preview={false} src={C68Img} />,
        link: 'https://coin68.com/infinite-launch-ila-coin/',
    },
    {
        name: 'ATK',
        logo: <Image className="partners-logo" preview={false} src={AtkImg} />,
    },
    {
        name: 'BAS',
        logo: <Image className="partners-logo" preview={false} src={BasImg} />,
    },
    {
        name: 'BENZINGA',
        logo: <Image className="partners-logo" preview={false} src={BenzingaImg} />,
        link: 'https://www.benzinga.com/pressreleases/21/11/24118558/diamond-hand-mechanism-for-the-first-time-applied-to-launchpad-by-infinite-launch',
    },
    {
        name: 'BITCOINIST',
        logo: <Image className="partners-logo" preview={false} src={BitcoinistImg} />,
        link: 'https://bitcoinist.com/infinite-launch-featured-on-kucoin-after-closing-2-2m-fundraising-rounds/',
    },
    {
        name: 'BLOOMBERG',
        logo: <Image className="partners-logo" preview={false} src={BloombergImg} />,
        link: 'https://www.bloomberg.com/press-releases/2021-11-22/with-outstanding-post-launching-achievements-infinite-launch-nft-marketplace-expects-to-become-the-second-opensea',
    },
    {
        name: 'BSCARMY',
        logo: <Image className="partners-logo" preview={false} src={BscarmyImg} />,
        link: 'https://www.bsc.news/post/ido-allocations-for-non-launchpad-token-holders-now-becomes-reality-with-infinite-launch',
    },
    {
        name: 'BUSSINESS INSIDER',
        logo: <Image className="partners-logo" preview={false} src={BussinessInsiderImg} />,
        link: 'https://markets.businessinsider.com/news/stocks/infinite-launch-finished-raising-2-2-million-with-its-unique-diamond-hand-mechanism-1030993201',
    },
    {
        name: 'CAFT',
        logo: <Image className="partners-logo" preview={false} src={CaftImg} />,
    },
    {
        name: 'SATOSH',
        logo: <Image className="partners-logo" preview={false} src={SatoshiImg} />,
    },
    {
        name: 'COINPOST',
        logo: <Image className="partners-logo" preview={false} src={CoinPostImg} />,
        link: 'https://coinpost.jp/?post_type=breaking&p=296063',
    },
    {
        name: 'COIN READER',
        logo: <Image className="partners-logo" preview={false} src={CoinReaderImg} />,
        link: 'https://www.coinreaders.com/14306',
    },
    {
        name: 'COIN TELE',
        logo: <Image className="partners-logo" preview={false} src={CoinTeleImg} />,
        link: 'https://cointelegraph.com/press-releases/ido-allocation-for-anyone-now-made-possible-by-infinite-launch',
    },
    {
        name: 'DJ',
        logo: <Image className="partners-logo" preview={false} src={DjImg} />,
    },
    {
        name: 'JINSE',
        logo: <Image className="partners-logo" preview={false} src={JinseImg} />,
        link: 'https://m.jinse.com/news/blockchain/1172239.html?source=m',
    },
    // {
    //     name: 'KIWI',
    //     logo: <Image className="partners-logo" preview={false} src={KiwiImg} />,
    // },
    {
        name: 'MARKET WATCH',
        logo: <Image className="partners-logo" preview={false} src={MarketWatchImg} />,
        link: 'https://www.marketwatch.com/press-release/with-outstanding-post-launching-achievements-infinite-launch-nft-marketplace-expects-to-become-the-second-opensea-2021-11-22?tesla=y',
    },
    {
        name: 'THE FINANCE',
        logo: <Image className="partners-logo" preview={false} src={TheFinanceSgImg} />,
    },
    {
        name: 'OMF FINANCE',
        logo: <Image className="partners-logo" preview={false} src={OmgFinnanceImg} />,
    },
    {
        name: 'PRN',
        logo: <Image className="partners-logo" preview={false} src={PrnImg} />,
    },
    {
        name: 'YAHOO',
        logo: <Image className="partners-logo" preview={false} src={YahooImg} />,
        link: 'https://finance.yahoo.com/news/diamond-hand-mechanism-first-time-124300301.html',
    },
    {
        name: 'CF',
        logo: <Image className="partners-logo" preview={false} src={CfImg} />,
    },
    {
        name: 'Investing',
        logo: <Image className="partners-logo" preview={false} src={InvestingImg} />,
    },
    {
        name: 'NewsBTC',
        logo: <Image className="partners-logo" preview={false} src={NewsBTCImg} />,
        link: 'https://www.newsbtc.com/news/company/infinite-launch-the-next-disruptive-launchpad-listing-on-kucoin-after-closing-2-2m-fundraising-rounds/',
    },
    {
        name: 'BLOCK SOLFI',
        logo: <Image className="partners-logo" preview={false} src={BlockSolfi} />,
    },
    {
        name: 'CHINA PUMNP',
        logo: <Image className="partners-logo" preview={false} src={ChinapumpImg} />,
    },
    {
        name: 'DAKU',
        logo: <Image className="partners-logo" preview={false} src={DakuImg} />,
    },
    {
        name: 'DEFI RACOONS',
        logo: <Image className="partners-logo" preview={false} src={DefiRacoonsImg} />,
    },
    {
        name: 'KTS',
        logo: <Image className="partners-logo" preview={false} src={KtsImg} />,
    },
];

const PartnersV2 = () => {
    return (
        <Wrapper data-aos="fade-down" data-aos-offset="100" data-aos-easing="ease-in-sine" data-aos-duration="500">
            <fieldset className="backers-fieldset">
                <legend className="fieldset-title">
                    <span className="title-our">As</span> <span className="title-backers title-our">Featured On</span>
                </legend>
                <Row className="home-section">
                    {listPartners.map((partner, idx) => {
                        const key = idx + 1;
                        return (
                            <Col key={key} lg={4} xs={8} className="logo-backer">
                                {partner.logo}
                            </Col>
                        );
                    })}
                </Row>
            </fieldset>
        </Wrapper>
    );
};

export default PartnersV2;
